import React, {Component} from "react";
import isEqual from 'lodash-es/isEqual';

import PropTypes from 'prop-types';
import classNames from 'classnames';
import DomHandler from '../../../../node_modules/primereact/components/splitbutton/../utils/DomHandler';
import Tooltip from "../../../../node_modules/primereact/components/splitbutton/../tooltip/Tooltip";
import Button from "../Button";
import {remoteLanguageFormatter} from "../../../utils/formatters";

export class SelectorGridPreFilters extends React.Component {

    componentDidUpdate(prevProps, prevState, prevContext) {

    }

    filterLabel = (filterSettings) => {
        if (filterSettings.label === null) {
            filterSettings.label = remoteLanguageFormatter(this.props.componentConfig.componentname)(filterSettings.token);
        }
        return filterSettings;
    }

    render() {
        const filters = this.props.filters || [];
        let content = null;
        let selected = null;
        if (filters.length) {
            content = <div className="prefilters btn-group">
                {this.props.resetAble && <button className={"btn btn-default"} onClick={(e) => {
                    if (this.props.onFilter) {
                        this.props.onFilter(null);
                    }
                    e && e.preventDefault();
                }}>{this.props.resetAble}</button>}
                {[...filters].map((filter, key) => {
                    if (filter.filters || filter.filters.length) {
                        let filterSettings = this.filterLabel({...filter});
                        let b = null;
                        const filters = [...(filterSettings.filters || [])].map((oldFilter) => {
                            let filter = this.filterLabel({...oldFilter});
                            filter.command = () => {
                                if (this.props.onFilter) {
                                    if (!filter.selected) {
                                        const f = {...filter};
                                        delete f.label;
                                        this.props.onFilter(f);
                                    } else {
                                        this.props.onFilter(null);
                                    }
                                }
                            }
                            if (((this.props.value || [])[0] || {}).id + "" === "" + (filter || {}).id) {
                                filter.selected = true;
                                selected = filter
                            }
                            return filter;
                        });
                        return <SplitButton key={key} ref={(t) => b = t} {...filterSettings} onClick={() => b.show()} model={filters}/>;
                    }
                })}
                {selected && <Button icon={{lib: "fa", name: "times", position: "right"}} color="default" onClick={(e) => {
                    if (this.props.onFilter) {
                        this.props.onFilter(null);
                    }
                    e && e.preventDefault();
                }}>{selected.label}</Button>}
            </div>;
        }
        return content;
    }
}


export class SplitButtonItem extends Component {

    static defaultProps = {
        menuitem: null
    }

    static propsTypes = {
        menuitem: PropTypes.any
    }

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    onClick(e) {
        if (this.props.menuitem.command) {
            this.props.menuitem.command({originalEvent: e, item: this.props.menuitem});
        }
        e.preventDefault();
    }

    render() {
        var className = classNames(this.props.menuitem.className, {'disabled': this.props.menuitem.disabled, selected: this.props.menuitem.selected});
        var icon = this.props.menuitem.icon ?
            <span className={classNames('icon', this.props.menuitem.icon)}/> : null;
        var label = <span className="text">{this.props.menuitem.label}</span>;

        return (
            <li className={className}>
                <a target={this.props.menuitem.target} href={this.props.menuitem.url || '#'} onClick={this.onClick}>
                    <span className={"p-checkbox p-component"}>
                        <span className={classNames("p-checkbox-box p-component", {"p-highlight": this.props.menuitem.selected})}>
                            <span className={classNames("p-checkbox-icon p-c", {"pi pi-check": this.props.menuitem.selected})}/>
                        </span>
                    </span>
                    {icon}
                    {label}
                </a>
            </li>
        );
    }
}


export class SplitButton extends Component {

    static defaultProps = {
        id: null,
        label: null,
        model: null,
        disabled: null,
        style: null,
        className: null,
        menuStyle: null,
        menuClassName: null,
        tabIndex: null,
        appendTo: null,
        tooltip: null,
        tooltipOptions: null
    }

    static propsTypes = {
        id: PropTypes.string,
        label: PropTypes.string,
        model: PropTypes.array,
        disabled: PropTypes.bool,
        style: PropTypes.object,
        className: PropTypes.string,
        menustyle: PropTypes.object,
        menuClassName: PropTypes.string,
        tabIndex: PropTypes.string,
        appendTo: PropTypes.object,
        tooltip: PropTypes.string,
        tooltipOptions: PropTypes.object
    }

    constructor(props) {
        super(props);

        this.onDropdownButtonClick = this.onDropdownButtonClick.bind(this);
    }

    onDropdownButtonClick(event) {
        if (this.documentClickListener) {
            this.dropdownClick = true;
        }

        if (this.panel.offsetParent)
            this.hide();
        else
            this.show();
    }

    show() {
        this.panel.style.zIndex = String(DomHandler.generateZIndex());
        this.panel.style.display = 'block';

        DomHandler.addClass(this.container, 'open');

        this.alignPanel();
        this.bindDocumentListener();
    }

    hide() {
        this.panel.style.display = '';
        DomHandler.removeClass(this.container, 'open');

        this.unbindDocumentListener();
        this.dropdownClick = false;
    }

    alignPanel() {
        if (this.props.appendTo) {
            DomHandler.absolutePosition(this.panel, this.container);
            this.panel.style.minWidth = DomHandler.getWidth(this.container) + 'px';
        }
        else {
            DomHandler.relativePosition(this.panel, this.container);
        }
    }

    bindDocumentListener() {
        if (!this.documentClickListener) {
            this.documentClickListener = () => {
                if (this.dropdownClick)
                    this.dropdownClick = false;
                else
                    this.hide();
            };

            document.addEventListener('click', this.documentClickListener);
        }
    }

    unbindDocumentListener() {
        if (this.documentClickListener) {
            document.removeEventListener('click', this.documentClickListener);
            this.documentClickListener = null;
        }
    }

    componentDidMount() {
        if (this.props.tooltip) {
            this.renderTooltip();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.tooltip && prevProps.tooltip !== this.props.tooltip) {
            if (this.tooltip)
                this.tooltip.updateContent(this.props.tooltip);
            else
                this.renderTooltip();
        }
    }

    componentWillUnmount() {
        this.unbindDocumentListener();

        if (this.tooltip) {
            this.tooltip.destroy();
            this.tooltip = null;
        }
    }

    renderTooltip() {
        this.tooltip = new Tooltip({
            target: this.container,
            content: this.props.tooltip,
            options: this.props.tooltipOptions
        });
    }

    renderItems() {
        if (this.props.model) {
            return this.props.model.map((menuitem, index) => {
                return <SplitButtonItem key={index} menuitem={menuitem}/>
            });
        }
        else {
            return null;
        }
    }

    render() {
        let className = classNames('btn-group', this.props.className, {'disabled': this.props.disabled});
        let items = this.renderItems();

        return (
            <div ref={(panel) => this.container = panel} className={className} id={this.props.id}>
                <button ref={(button) => this.button = button} tabIndex={this.props.tabIndex}
                        onClick={this.onDropdownButtonClick} type="button" className="btn btn-default dropdown-toggle"
                        data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                    {this.props.label} <span className="pi pi-chevron-down"/>
                </button>
                <ul ref={(el) => this.panel = el} className="p-multiselect-panel dropdown-menu">
                    {items}
                </ul>
            </div>
        );
    }
}